import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const Message = ({ id, tag, className }) => {
  const msg = (
    <FormattedMessage id={id}>
      {(txt) => <span dangerouslySetInnerHTML={{ __html: txt }}></span>}
    </FormattedMessage>
  );
  switch (tag) {
    case 'p':
      return <p className={className}>{msg}</p>;
    case 'h1':
      return <h1 className={className}>{msg}</h1>;
    case 'div':
      return <div className={className}>{msg}</div>;
    case 'span':
      return <span className={className}>{msg}</span>;
    default:
      return msg;
  }
};

Message.propTypes = {
  id: PropTypes.string.isRequired,
  tag: PropTypes.oneOf(['p', 'span', 'div', 'h1']),
};
